import React from "react";
import { LazyImage } from "react-lazy-images";

import LoadingAnimation from "../Layout/LoadingAnimations/loading";

import "./index.scss";

/*
Image component
INPUT
REQUIRED: source,
OPTIONAL: className, alt, placeholder, error

OUTPUT
  Component div.img
*/

export default function Image(props) {
  const { source, alt, className } = props;

  let placeholder = (
    <LoadingAnimation size={35} />
  );
  let error = (
    <img
      className={className}
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRfUUHljaxcfW3YkoLFM1olsqGwYkV6UGMX3NvZV0NXap5YQ0t4&usqp=CAU"
      alt="error"
    />
  );

  let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11){
    return (
      <img src={source} alt={alt} />
    )
  }
  if (props.placeholder) placeholder = props.placeholder;
  if (props.error) error = props.error;

  return (
    <LazyImage
      src={source}
      alt={alt}
      actual={(
        { imageProps } // each image to render
      ) => (
          <img className={className} {...imageProps} alt={alt} />
      )}
      placeholder={(
        { ref } // placeholder (loader) that shows while the actual image loads
      ) => (
        <div className={"placeholder " + className} ref={ref}>
          {placeholder}
        </div>
      )}
      error={() => <div className="error">{error}</div>} // element to render when an image fails to load
    />
  );
}
